import { Box, Flex, Progress, Text } from '@chakra-ui/react';
import { faHourglassHalf } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from '@morressier/alembic';

type IProps = {
  isOpen: boolean;
};

/**
 * Covers the submission while the run request is in flight. It closes on its
 * own as soon as that request settles and the panel starts polling, so there is
 * nothing here to dismiss it with — hence the no-op `onClose`, which is what
 * Escape and an overlay click would otherwise reach.
 */
const RunningChecksModal: React.FC<IProps> = ({ isOpen }) => (
  <Modal
    isOpen={isOpen}
    onClose={() => undefined}
    width="630px"
    closeButtonProps={{ display: 'none' }}
  >
    {/* One padded column, so the band below is inset by the same amount as the
        copy and the progress panel rather than running to the modal's edge. */}
    <Box padding={4}>
      {/* The icon block from `SubmissionLoader`: a full-width band with the icon
          centred in it. It must not sit inside a centred column, which would
          shrink the band to the width of the icon. */}
      <Flex
        justifyContent="center"
        alignItems="center"
        backgroundColor="neutralSecondaryFill"
        borderRadius="small"
        height="112px"
      >
        <FontAwesomeIcon icon={faHourglassHalf} fontSize="42px" />
      </Flex>

      <Flex
        flexDirection="column"
        alignItems="center"
        gap={1}
        marginTop={4}
        textAlign="center"
      >
        <Text textStyle="headingSection">Running Integrity Checks</Text>
        <Text textStyle="textBody">
          We are currently performing integrity checks on your submission. If we
          find any errors or failures, you will need to address those issues
          before resubmitting.
        </Text>
      </Flex>

      <Box
        borderWidth="1px"
        borderColor="neutralPrimaryBorder"
        borderRadius="small"
        padding={3}
        marginTop={6}
      >
        <Text textStyle="textContext">Running Integrity Checks…</Text>
        <Progress
          isIndeterminate
          size="sm"
          colorScheme="blue"
          borderRadius="small"
          marginTop={2}
        />
      </Box>
    </Box>
  </Modal>
);

export default RunningChecksModal;
